import { render, staticRenderFns } from "./split-detail-dialog.vue?vue&type=template&id=09efa984&scoped=true"
import script from "./split-detail-dialog.vue?vue&type=script&lang=js"
export * from "./split-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./split-detail-dialog.vue?vue&type=style&index=0&id=09efa984&prod&lang=scss&scoped=true"
import style1 from "./split-detail-dialog.vue?vue&type=style&index=1&id=09efa984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09efa984",
  null
  
)

export default component.exports